export default ({ $axios, DELAY_MS, $config }) => {
  $axios.interceptors.response.use(response => {
    if ($config.debug.isNetworkSlowdownActive) {
      return new Promise(resolve => setTimeout(() => resolve(response), DELAY_MS))
    }

    return Promise.resolve(response)
  })
}
